<div class="activate row">
  <div class="activate col-md-12">
    <div class="row">
      <div class="col-md-12">
        <h2>Almost done!</h2>
        <h3>Please create a user account to manage your application.</h3>
      </div>
    </div>
    <div class="row account-form">
      <form [formGroup]="accountForm" *ngIf="accountForm" autocomplete="off">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>User Name</mat-label>
                <input
                  matInput
                  id="displayName"
                  name="displayName"
                  formControlName="displayName"
                  placeholder="Enter user name"
                  type="email"
                  required>
                <mat-error
                  *ngIf="accountForm.get('displayName').touched && accountForm.get('displayName').errors">
                  Display Name is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>Confirmation Email Code</mat-label>
                <input
                  matInput
                  id="emailCode"
                  formControlName="emailCode"
                  placeholder="Enter confirmation email code"
                  type="text" 
                  autocomplete="off"
                  required trim="blur"/>
                <mat-error
                  *ngIf="accountForm.get('emailCode').touched && accountForm.get('emailCode').errors">
                  Email Code is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 error-messages">
              <small>
                <div
                  style="color: #ad2c23;"
                  *ngIf="emailSendError">
                  There was an error in sending the verification email. Please try again. 
                </div>
                <span *ngIf="!delayInterval">We sent you an email with a code to validate that you are the owner of the email account. 
                  Please enter that code above. If you did not get a code, please 
                    <a
                    [attr.href]="(requestCounter > 2 || requesting) ? null : '#'"
                    (click)="requestCounter <= 2 && !requesting && requestNewCode($event)"
                    >Request New Code</a>.
                </span>
                <span *ngIf="delayInterval"><strong>There have been too many requests to verify this email address. Please wait 5 minutes to receive the email before trying again.</strong></span>
                <br />
                
              </small>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input
                  matInput
                  id="password"
                  formControlName="password"
                  placeholder="Enter password"
                  type="password" 
                  autocomplete="off"
                  required />
                <mat-error
                  *ngIf="accountForm.get('password').touched && accountForm.get('password').errors && accountForm.get('password').errors.required">
                  Password is required
                </mat-error>
                <mat-error
                  *ngIf="accountForm.get('password').touched && accountForm.get('password').errors 
                    && (accountForm.get('password').errors.minlength || accountForm.get('password').errors.pattern)">
                  Password must meet all requirements.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input
                      matInput
                      formControlName="confirmPassword"
                      placeholder="Confirm password"
                      id="confirmPassword"
                      type="password" 
                      autocomplete="off"
                      [errorStateMatcher]="passwordMatcherEmail"
                      required />
                    <mat-error
                      *ngIf="accountForm.get('confirmPassword').touched && accountForm.get('confirmPassword').errors && accountForm.get('confirmPassword').errors.required">
                      Please re-enter your password
                    </mat-error>
                    <mat-error
                      *ngIf="accountForm.get('confirmPassword').touched && accountForm.errors?.password">
                      Passwords do not match
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <small>
                    Password must be 8 or more characters and at least one of each of the following from the list provided below:
                    <ul>
                      <li>Uppercase letter (A-Z)</li>
                      <li>Lowercase letter (a-z)</li>
                      <li>Digit (0-9)</li>
                      <li>Special character (~`!@#$%^)</li>
                    </ul>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row" *ngIf="messageDisplay">
      <div style="color: #ad2c23;" class="col-md-12">
        {{ messageDisplay }}<span *ngIf="messageDisplayShowLogout">, Please <a href (click)="logout($event)">Logout</a> to complete registration using that account.</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button
          type="button"
          matStepperPrevious
          id="go-back-button"
          mat-button>
          GO BACK
        </button>
        <button
          mat-raised-button
          class="complete float-right" color="primary"
          [disabled]="!continueEnabled()"
          (click)="submitAccount()"
          id="complete-button"
          type="button">
          COMPLETE
        </button>
      </div>
    </div>
  </div>
</div>

